var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"t-h2 u-blue u-pad-md",class:_vm.classText},[_vm._v(_vm._s(_vm.data.titre))])}
var staticRenderFns = []

export { render, staticRenderFns }